import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function topFunctions() {
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (prefersReducedMotion) return;

  const itemsContainer = document.querySelector(".p-top-functions__items");
  if (!itemsContainer) return;

  const items = itemsContainer.querySelectorAll(".p-top-functions__item");
  if (!items.length) return;

  const init = () => {
    const mm = gsap.matchMedia();

    // PC: items 全体が画面に入ったら6枚を順番に表示
    mm.add("(min-width: 769px)", () => {
      ScrollTrigger.create({
        trigger: itemsContainer,
        start: "top 85%",
        once: true,
        onEnter: () => {
          gsap.fromTo(
            items,
            { autoAlpha: 0, y: 30 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.8,
              ease: "power1.out",
              stagger: 0.3,
            }
          );
        },
      });
    });

    // SP: 各カードが画面に入ったタイミングで個別に表示
    mm.add("(max-width: 768px)", () => {
      items.forEach((item) => {
        ScrollTrigger.create({
          trigger: item,
          start: "top 90%",
          once: true,
          onEnter: () => {
            gsap.fromTo(
              item,
              { autoAlpha: 0, y: 30 },
              {
                autoAlpha: 1,
                y: 0,
                duration: 0.8,
                ease: "power4.out",
              }
            );
          },
        });
      });
    });

    ScrollTrigger.refresh();
  };

  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener("load", init, { once: true });
  }
}
